import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;

@Injectable()
export class HttpTokenService {
    tokenAuthUrl = DDP_ENV.tokenAuthUrl;
    tokenCheckUrl = DDP_ENV.tokenCheckUrl;
    grant_type = DDP_ENV.grant_type;
    refresh_token_grant_type = DDP_ENV.refresh_token_grant_type;
    auth_client_id = DDP_ENV.auth_client_id;
    auth_client_secret = DDP_ENV.auth_client_secret;
    authorization_token: string = btoa(this.auth_client_id + ':' + this.auth_client_secret);

    constructor(private _router: Router, private _http: Http, private cookieService: CookieService) { }

    /* Get token from authentication server */
    obtainAccessToken(loginData) {
        console.log(loginData);
        console.log(loginData.username);
        console.log(loginData.password);
        const params = this.createTokenParams(loginData);
        const options = this.buildHeaders();
        return this._http.post(this.tokenAuthUrl, params.toString(), options)
            .map(res => res.json());
    }

    /* get access token with refresh token. If valid, update access token */
    obtainAccessTokenWithRefreshToken() {
        const params = this.createRefreshTokenParams();
        const options = this.buildHeaders();
        return this._http.post(this.tokenAuthUrl, params.toString(), options)
            .map((res: Response) => {
                return res.json();
            });
    }

    /* Check token validity from auth server, if not valid try to get by refresh token - if not, log out user.*/
    check_token() {
        if (this.checkCredentials()) {
            const options = this.buildHeaders();
            const params = this.createCheckTokenParams();
            return this._http.post(this.tokenCheckUrl, params.toString(), options)
                .map((res: Response) => {
                    return res.json();
                });
        }
    }

    createTokenParams(loginData) {
        const params = new URLSearchParams();
        params.append('username', loginData.username);
        params.append('password', loginData.password);
        params.append('grant_type', this.grant_type);
        return params;
    }

    createCheckTokenParams() {
        const params = new URLSearchParams();
        params.append('token', this.cookieService.get('ecare_access_token').toString());
        return params;
    }

    createRefreshTokenParams() {
        const refresh_token = this.cookieService.get('ecare_refresh_token');
        if (refresh_token) {
            const params = new URLSearchParams();
            params.append('refresh_token', refresh_token);
            params.append('grant_type', this.refresh_token_grant_type);
            return params;
        } else {
            this._router.navigate(['/login']);
        }
    }

    /* Save token in cookie - NOT localstorage. */
    saveToken(token) {
        this.storeInCookie('ecare_access_token', token.access_token);
        this.storeInCookie('ecare_refresh_token', token.refresh_token);
        // this._router.navigate(['/dashboard']);
    }

    /* Check If cookie is available */
    checkCredentials() {
        if (!this.cookieService.get('ecare_access_token')) {
            this._router.navigate(['/login']);
        } else {
            return true;
        }
    }

    /* Handle error separately */
    private handleError(error: any) {
        console.error('ERROR: ' + JSON.stringify(error));
        return Observable.throw(error);
    }

    /* Store cookie */
    public storeInCookie(name: string, value: string) {
        this.cookieService.put(name, value);
    }

    private buildHeaders(): any {
        const headers = new Headers({'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'authorization': 'Basic ' + this.authorization_token});
        return new RequestOptions({ headers: headers });
    }
}
